import { IconButton, useTheme } from '@mui/material';
import { Nav, PageTitle } from './style';

import { usePageTitleContext } from '../../../../context/PageTitleContext';
import {
  useUserInfoMenu,
  UserAvatar,
} from '../../../Layout/components/UserInfo';
import Dropdown from '../../../common/DropDown';
import { useState } from 'react';

const Navbar = ({ handleDrawerOpen, userInfoData }) => {
  const { pageTitle } = usePageTitleContext();
  const theme = useTheme();
  const menuConfig = useUserInfoMenu(userInfoData);
  const [, setIsDropdownOpen] = useState(false);

  return (
    <Nav>
      <IconButton
        onClick={handleDrawerOpen}
        sx={{
          p: 0,
          width: 24,
          height: 24,
        }}
      >
        <img
          src={
            theme.palette.mode === 'dark'
              ? '/static/img/icon/Menu%20Icon-dark.svg'
              : '/static/img/icon/Menu%20Icon-light.svg'
          }
          alt="menu"
          style={{ width: '24px', height: '24px' }}
        />
      </IconButton>

      <PageTitle>{pageTitle.text || 'Place'}</PageTitle>

      <Dropdown
        hasHeader={menuConfig.hasHeader}
        hasFooter={menuConfig.hasFooter}
        list={menuConfig.list}
        rightItem
        openUpward={false}
        onOpenChange={setIsDropdownOpen}
        isLogout={!userInfoData}
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <UserAvatar
          userInfoData={userInfoData}
          sx={{
            width: { xs: theme.spacing(5), sm: theme.spacing(6.5) },
            height: { xs: theme.spacing(5), sm: theme.spacing(6.5) },
            borderRadius: '50%',
            backgroundColor: !userInfoData
              ? 'transparent'
              : theme.palette.secondary.main,
            cursor: 'pointer',
          }}
        />
      </Dropdown>
    </Nav>
  );
};

export default Navbar;
